import React, { Component } from "react";
import { Table } from "reactstrap";
import ComisionVentaModal from "./ComisionVentaModal";
import ComisionVentaRemovalModal from "./ComisionVentaRemovalModal";

class ComisionVentaList extends Component {

    componentDidMount() {
    }  
    render() {
      
      const {estudiantesIngreso, admins, proyectoMoneda} = this.props;
      const ingreso = Number(estudiantesIngreso) || 0;
      return (
        <div>
          <Table responsive hover striped bordered>
            <thead>
              <tr className="table-danger">
                <th>Comision de Venta</th>
                <th>Cantidad</th>
                <th>Porcentaje de Commission</th>
                <th>Moneda</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {!admins || admins.length <= 0 ? (
                <tr>
                  <td colSpan="15" align="center">
                    <b>Ups, todavia no comisiones de venta!!</b>
                  </td>
                </tr>
              ) : (
                admins.map(admin => {
                  const sub = Number(admin.subcantidad) || 0;
                  const pct = ingreso > 0 ? (sub / ingreso * 100) : 0;
                  return (
                  <tr key={admin.pk}>
                    <td>{admin.instructor}</td>
                    <td>{sub.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td>{pct.toFixed(2)}%</td>
                    <td>{admin.moneda}</td>
                    <td align="center">
                        <ComisionVentaModal
                        create={false}
                        admin={admin}
                        resetState={this.props.resetState}
                        partners = {this.props.partners}
                        proyectoCodeSelected = {this.props.proyectoCodeSelected}
                        proyectoNameSelected = {this.props.proyectoNameSelected}
                        proyectoMoneda={proyectoMoneda}
                        estudiantesIngreso = {estudiantesIngreso}
                        />
                        &nbsp;&nbsp;
                        <ComisionVentaRemovalModal
                        pk={admin.pk}
                        resetState={this.props.resetState}
                        />
                    </td>

                  </tr>
                  );
                })
              )}
            </tbody>
          </Table>
  
        </div>
      );
    }
  }
  
  export default ComisionVentaList;